import { NgModule, LOCALE_ID } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ToastrModule } from 'ngx-toastr';
import { SpinnerComponent } from '../components/util/spinner/spinner.component';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatSelectModule } from '@angular/material/select';
import { MatStepperModule } from '@angular/material/stepper';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTabsModule } from '@angular/material/tabs';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDividerModule } from '@angular/material/divider';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuModule } from '@angular/material/menu';
import { AccessDeniedComponent } from './components/access-denied/access-denied.component';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { AutocompleteComponent } from './components/autocomplete/autocomplete.component';
import { EvenNumberPipe } from './pipes/even-number.pipe';
import { RoundNumberPipe } from './pipes/round-number.pipe';
import { CurrencyMaskDirective } from './directives/currency-mask.directive';
import { registerLocaleData } from '@angular/common';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import localePt from '@angular/common/locales/pt';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { ToastComponent } from '../components/util/toast/toast.component';
import { StaffPlanPrazoDialogComponent } from './components/staff-plan-prazo-dialog/staff-plan-prazo-dialog.component';

registerLocaleData(localePt);

@NgModule({
  declarations: [
    SpinnerComponent,
    AccessDeniedComponent,
    ConfirmDialogComponent,
    NotFoundComponent,
    AutocompleteComponent,
    EvenNumberPipe,
    RoundNumberPipe,
    CurrencyMaskDirective,
    ToastComponent,
    StaffPlanPrazoDialogComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    MatCardModule,
    MatFormFieldModule,
    MatTableModule,
    MatPaginatorModule,
    MatCheckboxModule,
    MatButtonModule,
    MatInputModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatStepperModule,
    MatDialogModule,
    MatTabsModule,
    MatExpansionModule,
    ReactiveFormsModule,
    MatDividerModule,
    MatChipsModule,
    MatProgressSpinnerModule,
    ToastrModule.forRoot({ positionClass: 'toast-top-right' }),
    MatIconModule,
    MatTooltipModule,
    MatMenuModule,
    MatDatepickerModule,
    MatNativeDateModule,
    NgxMaskDirective,
    NgxMaskPipe,
  ],
  exports: [
    CommonModule,
    FormsModule,
    RouterModule,
    MatCardModule,
    MatFormFieldModule,
    MatTableModule,
    MatPaginatorModule,
    MatCheckboxModule,
    MatButtonModule,
    MatInputModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatStepperModule,
    MatDialogModule,
    MatTabsModule,
    MatExpansionModule,
    ReactiveFormsModule,
    MatDividerModule,
    MatChipsModule,
    MatProgressSpinnerModule,
    ToastrModule,
    MatIconModule,
    SpinnerComponent,
    MatTooltipModule,
    MatMenuModule,
    AutocompleteComponent,
    EvenNumberPipe,
    RoundNumberPipe,
    CurrencyMaskDirective,
    MatDatepickerModule,
    MatNativeDateModule,
    NgxMaskDirective,
    NgxMaskPipe,
    ToastComponent,
  ],
  providers: [{ provide: LOCALE_ID, useValue: 'pt' }, MatDatepickerModule, provideNgxMask()],
})
export class SharedModule {}
